export const UserRole = {
    STUDENT: 'STUDENT',
    TEACHER: 'TEACHER',
    ADMIN: 'ADMIN',
};
export const ApprovalStatus = {
    PENDING: 'PENDING',
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED',
};
export const SubjectSlug = {
    PIANO: 'piano',
    VOCAL: 'vocal',
    GUITAR: 'guitar',
    ELECTRIC_GUITAR: 'electric-guitar',
    DRUMS: 'drums',
    HANDPAN: 'handpan',
    VIOLIN: 'violin',
};
export const SkillLevel = {
    BEGINNER: 'BEGINNER',
    INTERMEDIATE: 'INTERMEDIATE',
    ADVANCED: 'ADVANCED',
};
export const LessonType = {
    TRIAL: 'TRIAL',
    REGULAR: 'REGULAR',
};
export const BookingStatus = {
    PENDING: 'PENDING',
    CONFIRMED: 'CONFIRMED',
    ATTENDED: 'ATTENDED',
    NO_SHOW: 'NO_SHOW',
    CANCELLED: 'CANCELLED',
};
export const PaymentStatus = {
    UNPAID: 'UNPAID',
    PAID: 'PAID',
    REFUNDED: 'REFUNDED',
};
export const RoomAvailabilityState = {
    AVAILABLE: 'AVAILABLE',
    LIMITED: 'LIMITED',
    FULL: 'FULL',
};
export const Locale = {
    AZ: 'az',
    EN: 'en',
    RU: 'ru',
};
export const SUPPORTED_LOCALES = [Locale.AZ, Locale.EN, Locale.RU];
export const DEFAULT_LOCALE = Locale.EN;
export const ACADEMY_TIMEZONE = 'Asia/Baku';
export const TRIAL_DURATION_MINUTES = 30;
export const REGULAR_DURATION_MINUTES = 60;
export const ROOM_SLOT_MINUTES = 60;
export const BOOKING_HOLD_MINUTES = 15;
export const NotificationCategory = {
    LESSON: 'LESSON',
    SCHEDULE: 'SCHEDULE',
    ROOM: 'ROOM',
    PAYMENT: 'PAYMENT',
    COMMUNITY: 'COMMUNITY',
};
export const NOTIFICATION_CATEGORIES = [
    NotificationCategory.LESSON,
    NotificationCategory.SCHEDULE,
    NotificationCategory.ROOM,
    NotificationCategory.PAYMENT,
    NotificationCategory.COMMUNITY,
];
export const PaymentPeriodStatus = {
    DUE: 'DUE',
    PAID: 'PAID',
    OVERDUE: 'OVERDUE',
    REFUNDED: 'REFUNDED',
};
export const CommunityTopic = {
    TECHNIQUE: 'technique',
    THEORY: 'theory',
    PRACTICE: 'practice',
    INSTRUMENTS: 'instruments',
    PERFORMANCE: 'performance',
    ACADEMY: 'academy',
};
export const COMMUNITY_TOPICS = [
    CommunityTopic.TECHNIQUE,
    CommunityTopic.THEORY,
    CommunityTopic.PRACTICE,
    CommunityTopic.INSTRUMENTS,
    CommunityTopic.PERFORMANCE,
    CommunityTopic.ACADEMY,
];
export const ScheduleEntryKind = {
    LESSON: 'LESSON',
    TRIAL: 'TRIAL',
    ROOM: 'ROOM',
    CANCELLED: 'CANCELLED',
};
export const ScheduleFilter = {
    ALL: 'all',
    LESSONS: 'lessons',
    ROOMS: 'rooms',
};
export const NOTIFICATION_PREFERENCE_KEYS = [
    'lessonReminders',
    'bookingConfirmations',
    'paymentReminders',
    'scheduleChanges',
    'communityReplies',
    'academyNews',
];
export const AttendanceMark = {
    UNMARKED: 'UNMARKED',
    PRESENT: 'PRESENT',
    ABSENT: 'ABSENT',
    LATE: 'LATE',
};
export const ATTENDANCE_OPTIONS = [
    AttendanceMark.PRESENT,
    AttendanceMark.ABSENT,
    AttendanceMark.LATE,
];
export const AttendanceRange = {
    TODAY: 'today',
    WEEK: 'week',
    PENDING: 'pending',
};
export const ScheduleView = {
    WEEK: 'week',
    DAY: 'day',
    LIST: 'list',
};
export const SlotState = {
    AVAILABLE: 'AVAILABLE',
    PAST: 'PAST',
    UNAVAILABLE: 'UNAVAILABLE',
    LESSON: 'LESSON',
    TRIAL: 'TRIAL',
    PRESENT: 'PRESENT',
    ABSENT: 'ABSENT',
    LATE: 'LATE',
    CANCELLED: 'CANCELLED',
};
export const SLOT_LEGEND_STATES = [
    SlotState.AVAILABLE,
    SlotState.TRIAL,
    SlotState.LESSON,
    SlotState.PRESENT,
    SlotState.ABSENT,
    SlotState.CANCELLED,
    SlotState.UNAVAILABLE,
];
export const SCHEDULE_GRID_START_MINUTE = 10 * 60;
export const SCHEDULE_GRID_END_MINUTE = 21 * 60;
export const SCHEDULE_GRID_STEP_MINUTES = 30;
export const StudentStanding = {
    ON_TRACK: 'ON_TRACK',
    MISSED: 'MISSED',
    TRIAL: 'TRIAL',
};
export const StudentScope = {
    ALL: 'all',
    TRIALS: 'trials',
    ATTENTION: 'attention',
};
export const TEACHER_NOTIFICATION_PREFERENCE_KEYS = [
    'newBookings',
    'cancellations',
    'attendanceReminders',
    'communityReplies',
];
export const CommunityScope = {
    UNANSWERED: 'unanswered',
    ALL: 'all',
};
//# sourceMappingURL=enums.js.map